// extracted by mini-css-extract-plugin
export default {"one":"Collections_one__zYEFt","two":"Collections_two__BII+n","three":"Collections_three__SYHjn","four":"Collections_four__PZ1SC"};